import React, 
  {createContext, 
  useState, 
  useContext,
  useCallback } from "react";

const PricingContext = createContext();

export const usePricing = () => useContext(PricingContext);

export const PricingProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    id: null,
    lucroPercent:0,
    impostoPercent:0,
    sugestedPrice:0,
    nomeProjeto: "",
    tipoProjeto: "",   
    custosFixos: [],
    custosVariaveis: [],
    funcionarios: [],
    dadosCliente: {},
    venda: [],
    levantamento: [],
    estudoPreliminar:[],
    anteprojeto:[],
    projetoLegal:[],
    projetoExecutivo: [],
    acompanhamentoObra:[],
    custosAdicionais: [],
    idCliente: null,
  });

  const updateFormData = (section, data) => {
    setFormData((prev) => ({ ...prev, [section]: data }));
  };

  const loadFormData = useCallback((partialOrUpdater) => {
    setFormData((prev) => {
      const next =
        typeof partialOrUpdater === 'function'
          ? partialOrUpdater(prev)
          : { ...prev, ...partialOrUpdater };

      const same =
        prev === next ||
        (Object.keys(prev).length === Object.keys(next).length &&
          Object.keys(prev).every((k) => prev[k] === next[k]));

      return same ? prev : next;
    });
  }, []);

  const contextValue = React.useMemo(
    () => ({ formData, updateFormData, loadFormData }),
    [formData]
  );

  return (
    <PricingContext.Provider value={contextValue}>
      {children}
    </PricingContext.Provider>
  );
};